
define('eteration/eteration-ajax',['jquery' ,
		'underscore',
		'eteration/eteration-i18n',
		'eteration/ui/validation-helper',
		'eteration/eteration-urlparser',
		'ui-helper/cookie-helper',
		'ui-helper/storage-helper',
		'common/recaptcha-constants',
		'jstorage',
		'bootstrap',
		'application'],

function($,underscore,i18n,validationHelper,urlParser,cookieHelper, storageHelper, recaptchaConstants) {
	var preloaderStaticTemp = '<div class="preloader-mask" style="display: none;"><div class="animation-area"><div class="animation-border"></div><img src="/theme/img/LoadingGif/animation.gif" alt="THY Loading Animation GIF"></div></div>';
	var serviceRegistry = null;
	var ajaxLoaderClearTimeout = 170;
	var ajaxCallCount = 0, loaderTimeout, largeLoaderTimeout;
	var loaderOpen = false, loadersVisible = false, preloaderEl, recaptchaRefId = 0;
	var allAppLinks = null;
	var altTagCounter=0;
	var loadAltText = "Label-ALT-Loader";
	var loadImage = ".preloader-mask .animation-area img";
	var loadAltTag = function (){
		if(i18n.get(loadAltText)!=loadAltText&& altTagCounter < 30) {
			$(loadImage).attr({'alt':i18n.get(loadAltText)});
		}else{
			setTimeout(function(){
				altTagCounter++;
				loadAltTag();
				}, 1000);
		  }	
      };	
	loadAltTag();

	var setLoaderTemplate = function (template) {
		loadersVisible = false;
		$('.preloader-mask').remove();
		preloaderStaticTemp = template;
	}
	var loadAppLinks = function() {
		if($.isEmptyObject(allAppLinks)) {
			var apps = $( "div[aref]");
			allAppLinks = {};
			for(var i=0;i<apps.length ;i++) {
				var id = $(apps[i]).attr("id");
				$.extend( true, allAppLinks,window[id+"Links"]);
			}
		}
	};
	
	var callCallbackSafely = function(callbackFunction, callbackArg) {
		try {
			if(callbackFunction) {
				callbackFunction(callbackArg);
			}
		} catch (e) {
			console.error(e);
		}
	}
	
	var parseRedirectUrl = function(redirectUrl) {
		
		loadAppLinks();
		
		var ref = document.location.protocol+"//"+document.location.host+redirectUrl;
		var baseLink = redirectUrl;
		var parameterIndex = redirectUrl.indexOf("?");
		var urlParams = ""
		if(parameterIndex>0) {
			urlParams= baseLink.substring(parameterIndex);
			baseLink = baseLink.substring(0,parameterIndex);
			
			baseLink = baseLink.substring(0,parameterIndex);
			baseLink = baseLink.replace(/;jsessionid=(.*)$/, '');
		} else {
			baseLink = baseLink.replace(/;jsessionid=(.*)$/, '');
		}
		
		if(allAppLinks[baseLink]) {

			ref = document.location.protocol+"//"+document.location.host+allAppLinks[baseLink]+urlParams;
		}
		return ref;
	}

		var addCaptcha = function(headerText, msgCodes) {
			if(!headerText) {
				headerText = "Label-Genel-203";
			}

			var captchaMessageContent = "";
			for(var i=0; i < msgCodes.length; i++) {
				var msgCode = msgCodes[i].code;
				captchaMessageContent += '<div class="alert alert-attention noborder">'+
					'<div class="col-2"><i class="fa fa-info-circle blue fa-3x float-start"></i></div>'+
					'<div class="col-10 nopadding">'+
					'<h4>'+i18n.get(headerText)+'</h4>'+
					'<p class="word-wrap">'+i18n.get(msgCode)+'</p>'+
					'</div>' +
					'</div>';
			}

			var modalhtml = '<div class="modal" tabindex="-1" role="dialog" data-bs-backdrop="static" id="captchaModalPopup">'+
				'<div class="modal-dialog">'+
				'<div class="modal-content">'+
				'<div class="modal-body panel-body">'+
				'<div class="row grid-top">'+
				'<div class="col-12">'+
				'<div id="captchaMessage">'+
				captchaMessageContent +
				'</div>'+
				'<div class="pl-30"><div class="g-recaptcha" id="captchaModal" data-callback="recaptchaCallback" data-sitekey="6LfvwDMUAAAAALBHKMRVZPZmKygAvKtTQxQ1TCcI"></div></div>'+
				'</div>'+
				'</div>'+
				'<div class="row grid justify-content-end">'+
				'<div class="col-4 float-end" data-bs-dismiss="modal">'+
				'<a id="captchaModalCloseButton" class="w-100 btn btn-danger btn-block btn-lg">'+i18n.get('Label-Genel-201')+'</a>'+
				'</div>'+
				'</div>'+
				'</div>'+
				'</div>'+
			'</div>'+
		'</div>';
		
		if(!$('#captchaModalContainer').length) {
			$('body').append('<div id="captchaModalContainer"></div>');
			document.getElementById("captchaModalContainer").innerHTML = modalhtml;
			if(window.grecaptcha) {
				$("#captchaModal").empty();
				recaptchaRefId = window.grecaptcha.render('captchaModal', {'sitekey': '6LfvwDMUAAAAALBHKMRVZPZmKygAvKtTQxQ1TCcI'});
			}
		} else {
			window.grecaptcha && window.grecaptcha.reset(recaptchaRefId);
			document.getElementById('captchaMessage').innerHTML = captchaMessageContent;
		}
	}
	
	var showCaptchaModal = function(headerText, msgCodes) {
		addCaptcha(headerText, msgCodes);
		
		if($('#errorModal').length > 0) {
			$('#errorModal').modal("hide");
		}
		setTimeout(function() {
			$('#captchaModalPopup').modal("show");
		}, 250);
		
		// close button event listener
		$("#captchaModalCloseButton").on({
			click: function() {
				try {
					if(!(window.grecaptcha && window.grecaptcha.getResponse(recaptchaRefId))) {
						return false;
					}
				} catch(err) {
					return true;
				}
			}
		});
		$("#captchaModalCloseButton").length && $._data($("#captchaModalCloseButton")[0], "events");
	}

	var returnHomepageErrors = ["ERR-GENEL-08","Error-CHI-711","Error-CHI-712","Error-BOS-17043"];
	var returnMyTripsErrors = ["Error-BOS-17028","Error-BOS-28031","Error-BOS-28032"];

	var handleAjaxError = function(response, preErrorProperties, reloadPageCSRF, returnHomepageLinkOnError, returnHomepageErrorCodeList, returnToHomepageOnExceptionError, returnToMyTripsOnExceptionError) {
		if(response && response.type == "CAPTCHA") {
			showCaptchaModal('', response.error.validationMessages);
			return false;
		}

		var responseMessagesFlag = response.error && response.error.messages && response.error.messages.length > 0;
		if(responseMessagesFlag && returnHomepageErrors.includes(response.error.messages[0].code) && returnToHomepageOnExceptionError) {
			showErrorModal([response.error.messages[0].code], returnToHomepageOnExceptionError);
			return true;
		}

		if(responseMessagesFlag && returnMyTripsErrors.includes(response.error.messages[0].code) && returnToMyTripsOnExceptionError) {
			showErrorModal([response.error.messages[0].code], returnToMyTripsOnExceptionError);
			return true;
		}

		if(responseMessagesFlag && returnMyTripsErrors.includes(response.error.messages[0].code) && returnToMyTripsOnExceptionError) {
			showErrorModal([response.error.messages[0].code], returnToMyTripsOnExceptionError);
			return true;
		}

		var modalParams;
		if(response.infoMessages && response.infoMessages.length) {
			if(response.type === "WARNING") {
				modalParams = {
					msgs: response.infoMessages,
					reloadPage: reloadPageCSRF,
					link: returnHomepageLinkOnError,
					type: 'warning'
				};
				createValidationModal(modalParams);
			} else if(response.type === "INFORMATION") {
				modalParams = {
					msgs: response.infoMessages,
					reloadPage: reloadPageCSRF,
					link: returnHomepageLinkOnError,
					type: 'info'
				};
				createValidationModal(modalParams);
			}
			return false;
		} else if(response.error && (response.error.type === "FAILURE" || response.type === "WARNING")) {
			
			if(!response.error.validConversation) {
				var flag = false;				
				
				var cid = urlParser.getUrlVar("cId");
				var terminatedByCountLimitConversationIds = $.jStorage.get("app/terminatedByCountLimitConversationIds");
				if(terminatedByCountLimitConversationIds != null) {
					 flag = terminatedByCountLimitConversationIds.includes(cid);
				}
				
				if(!flag)
					console.log("Invalid Conversation");
				else
					console.log(i18n.get('ERR-GENEL-04'));
				
				var redirectPage = findStartPageForRedirect(sessionStorage);
				window.location.replace(redirectPage);	
				return;
			}
			
			if(response.error.messages && response.error.messages.length > 0) {
				var covidErrors = 0;
				underscore.each(response.error.messages, function(message) {
					try {
						message.code.toUpperCase() == 'ERROR-BOS-38010' && message.extraParameters && message.extraParameters.length && covidErrors++;
					} catch (e) {

					}
				});
				
				if(covidErrors) {
					createCovidModal(response);
				} else {
					if(returnHomepageErrorCodeList) {						
						var link = null;
						underscore.each(response.error.messages, function(message) {
							if(underscore.contains(returnHomepageErrorCodeList, message.code)) {
								link = returnHomepageLinkOnError;
							}
						});
						returnHomepageLinkOnError = link;
					}
					modalParams = {
						type:'error',
						reloadPage: reloadPageCSRF,
						requestId: response.error.requestID,
						msgs: response.error.messages,
						link: returnHomepageLinkOnError
					};
					createValidationModal(modalParams);
				}
			} else {
				modalParams = {
					type:'error',
					reloadPage: reloadPageCSRF,
					requestId: response.error.requestID || response.error.validationMessages[response.error.validationMessages.length - 1].id,
					msgs: response.error.validationMessages
				}; 
				createValidationModal(modalParams);
			}
			callPreErrorFunction(preErrorProperties);
			
			return true;
		}
		
		return false;
	}
	
	function findStartPageForRedirect(psessionStorage) {
		var redirectPage = ""; 
		try {
			var cname = "startScheduculePageUrl=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(cname) === 0) {
					redirectPage = c.substring(cname.length, c.length);
					if(redirectPage.indexOf("?") === 0) {
						var pos = redirectPage.indexOf("?");
						if(pos > -1) {
							redirectPage = redirectPage.substring(0,pos );
						}
					}
					
				}
			}
		} catch (e) {

		}
		
		if(!redirectPage) {
			redirectPage = psessionStorage.getItem("startScheduculePageUrl") || window.startUrl || window.location.protocol+"//"+window.location.hostname;
		}
		
		var index = redirectPage.indexOf("?");
		if(index > -1) {
			redirectPage= redirectPage.substring(0,pos );
		}
		return redirectPage;
	}
	
	var handleValidationError = function(response, uiMap, preErrorProperties, modalParams) {
		if(response.error && response.error.type == "INVALID_DATA") {
			var msg = response && ((response.infoMessages && response.infoMessages.length) || (response.error && response.error.validationMessages[0]));
			if(!$("#errorContent").length && msg) {
				createValidationModal(modalParams);
			} else if(uiMap) {
				validationHelper.showServerErrors(response.error.validationMessages,uiMap);
			} else {
				validationHelper.showHeaderErrors(response.error.validationMessages);
			}
			callPreErrorFunction(preErrorProperties);
			return true;
		}
		
		return false;
	};
	
	var loadServiceRegistry = function() {
		serviceRegistry = {
				"app.cms":"/com.thy.web.online.cms/cms",
				"app.evisa":"/com.thy.web.online.evisa/evisa",
				"app.ms":"/com.thy.web.online.miles/ms",
				"app.investorrelations":"/com.thy.web.online.matriks/matriks",
				"app.tccbooking":"/com.thy.web.online.tccbooking/tccbooking",
				"app.additionalservices":"/com.thy.web.online.additionalservices/additionalservices",
				"app.cc":"/com.thy.web.online.corporateclub/corporateclub",
				"app.flightmap":"/com.thy.web.online.flightmap/flightmap",
				"app.baggage":"/com.thy.web.online.baggage/baggage",
				"app.tkconventions":"/com.thy.web.online.tkconventions/tkconventions",
				"app.timetable":"/com.thy.web.online.timetable/timetable",
				"app.investor":"/com.thy.web.online.investorrelations/investorrelations",
				"app.search":"/com.thy.web.online.search/search",
				"app.ibs":"/com.thy.web.online.ibs/ibs",
				"app.deparr":"/com.thy.web.online.deparr/deparr",
				"app.common":"/com.thy.web.online.common/api",
				"app.mim":"/com.thy.web.online.mim/mim"
		};
	}
	
	function endAndStartLoaderTimer() {
		window.clearTimeout(loaderTimeout);
		window.clearTimeout(largeLoaderTimeout);
		largeLoaderTimeout = window.setTimeout(function() {
			stopLoadingLarge();
		},7000);
		
		loaderTimeout = window.setTimeout(function() {
			$('.preloader-mask').hide();
		},10000);
	}
	
	var callPreErrorFunction = function(preErrorProperties) {
		if(preErrorProperties) { 
			preErrorProperties.preErrorFunction.apply(preErrorProperties.preErrorFunction, preErrorProperties.preErrorArgs); 
		}
	}

	var loaderQuery = function (loaderName, callback) {
		if (!loaderName) {
			loaderName = "select_flights";
		}

		var loaderData = {
			"language": i18n.getUserLocale(),
			"country": i18n.getUserCountry(),
			"schema": "Loader Block",
			"keyword": [{
				"Application Metadata": "largeloader_" + loaderName,
			}],
			"template": "Loader Block",
			"maxItems": 1
		};

		var promise = $.ajax({
			url: "/com.thy.web.online.cms/cms/content/query",
			dataType: "json",
			contentType: 'application/json',
			method: 'POST',
			data: JSON.stringify(loaderData),
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Accept-Language", i18n.getUserLocale());
				xhr.setRequestHeader("country", i18n.getUserCountry());
			},
			success: function (response) {
				if (callback && response.data && response.data.components.length > 0) {
					callback(response.data.components[0].html);
				} else {
					$(".preloader-mask").show();
				}
			},
			error: function (_xhr, _textStatus, _errorThrown) {
				$(".preloader-mask").show();
			}
		});

		return promise;
	};
	
	var getLoaderContainer = function() {
		var cont = $('#allLoaderContainer');
		if(!cont.length) {
			cont = $('<div id="allLoaderContainer"></div>').appendTo('body');
		}
		return cont;
	}
	
	var getLoaderKey = function(key) {
		return key && key.replace(' ','_') + 'LoaderTemplate';
	}
	
	var loadLargeLoader = function(loaderName) {
		return loaderQuery(loaderName,function(htmlText) {
			var loadingEl = $(htmlText).find('.loading-anim').parents('.modal');
			if(loadingEl.length) {
				var id = getLoaderKey(loaderName);
				loadingEl.attr('id', id);
				loadingEl.find(".modal-dialog").css({ 'top': '5%' });
				loadingEl.find('.loading-anim').remove();
				loadingEl.find('.loading-bg').before('<div class="prgrss"><div class="prc"></div></div>');
				getLoaderContainer().append(loadingEl);
				loadingEl.on('shown.bs.modal',function() {
					$('.loading-bg').height(0);
					if($('.loading-bg img.single-bg').length>0) {
						$('.loading-bg img.single-bg').on('load', function() {
							$('.loading-bg').height($(this).height());
							$(this).css({'z-index':"1"});
						});							
						$(".preloader-mask-override").hide();
						$(".preloader-mask").hide();
					}
					$(".loading").css({ 'z-index': '2501' });
					$('.loading .modal-dialog').animate({top: '5%'});
				});
				contentheight();
				window[id] = loadingEl;
			} else {
				$(".preloader-mask").show();
			}
		});
	};
	
	var appendAllLoader = function() {
		if(loadersVisible)
			return;
		preloaderEl = $(".preloader-mask");
		if(!preloaderEl.length) {
			i18n.loadMsgs(['common'],function() {
				preloaderStaticTemp = preloaderStaticTemp.replace("$Label-Genel-199", i18n.get('Label-Genel-199'));
				preloaderEl = $(preloaderStaticTemp);
				if(!preloaderEl.length) {
					preloaderEl = $(i18n.get('html.AppLoading'));
				}
				getLoaderContainer().append(preloaderEl.hide());
			},"ajaxcommon");
		}
		
		loadersVisible = true;
	}
	
	loadServiceRegistry();	
	loadAppLinks();
	var startLoading = function(loaderName,largeLoader,disableLoaderTimeout) {
		var promise = $.when('');
		appendAllLoader();
		if(!largeLoader && !loaderOpen) {
			promise = $.when(preloaderEl.show());
		} else {
			if(loaderName && largeLoader) {
				promise = startLoadingLarge(loaderName);
			} else{
				if($('.loading').length == 0) {
					promise = $.when(preloaderEl.show());
				}

			}
			loaderOpen = true;
		}

		
		if(disableLoaderTimeout) {
			window.clearTimeout(loaderTimeout);
		} else {
			endAndStartLoaderTimer();
		}
		
		return promise;
	};
	
	var stopLoading = function(largeLoader) {
		setTimeout(function() {
			if(!window.preventStopLoading ) {
				if(largeLoader === "all") {
					$(".preloader-mask").hide();
					stopLoadingLarge();
				} else {
					if(!largeLoader) {
						$(".preloader-mask").hide();
					} else {
						stopLoadingLarge();
					}
				}
				loaderOpen = false;
			}
			
		}, 10);
	};
	
	var startLoadingLarge = function(loaderName) {
		var promise = $.when('');
		
		if(loaderOpen) return promise;
		
		var id = getLoaderKey(loaderName);
		if(!window[id]) {
			promise = loadLargeLoader(loaderName);
		}
		if(!promise)
			promise = $.when(window[id])
		promise.then(function() {
			if($('.loading').length != 0) {
				setTimeout(function() {
					preloaderEl.hide();
				}, 1000);
			}

			window[id] && window[id].modal('show');
			try{
				storageHelper.setItem({
					key: "lastLoader",
					value: '',
					webStorageType: storageHelper.Stores.SESSION_STORAGE
				});
			}catch (e) {
				console.dir(e);
			}
		})
		return promise;
	};
	
	var stopLoadingLarge = function() {
		$('.loading').modal('hide');
	};
	
//	createValidationModal usage information
//	type: error,info,warning
//	title: modal title, has defaults
//	msgs: code array of messages (may be backend object which has "code,msg")
//	callback: function for trigger event etc.
//	requestId: on error show request id
//	link: after click ok button go to link
//	reloadPage: after click ok button reload page
//	hasIcon: show text with warning etc. icon
		var createValidationModal = function(params) {
			var iconClass = '';
			var wrapperId = '';
			var title = params.title;
			var msgs = Array.isArray(params.msgs) ? params.msgs : [params.msgs];
			var requestId = params.requestId;
			var hasIcon = params.hasIcon != undefined ? params.hasIcon : true;
			if(params.type == 'error') {
				iconClass = 'fa-exclamation-triangle red';
				wrapperId = 'errorModal';
				if(!title) {
					title = '';
				}
				if(!msgs || !msgs.length) {
					msgs = ['ERR-GENEL-08'];
				}
				if(requestId) {
					requestId.indexOf('Error') ? requestId = requestId.replace('Error-', '') : requestId = 'RUN-' + requestId;
				}
			} else if(params.type == 'warning') {
				iconClass = 'fa-exclamation-triangle gold';
				wrapperId = 'warningModal';
				if(!title) {
					title = 'modal.warning.title';
				}
			} else if(params.type == 'info') {
				iconClass = 'fa-info-circle blue';
				wrapperId = 'infoModal';
				if(!title) {
					title = 'Label-Genel-203';
				}
			}
			if(Array.isArray(msgs) && msgs.length) {
				requestId = msgs[0].id || requestId;
			}

			var messages = '', text = '';
			underscore.each(msgs, function(msg) {
				text = (typeof msg === 'object') ? (msg.code ? i18n.get(msg.code) : msg.msg) : i18n.get(msg);
				params.type == 'error' && text == msg.code && text.replace('Error-', '');
				messages += '<p class="word-wrap">' + text + '</p>';
			});

			var modalButton = requestId ? ('<div class="col-6"><h5 class="tk-grey fs-10 pl-65 pl-0-mbl">' + requestId + '</h5></div>') : '';
			modalButton += !params.link ? ('<div class="col-6 float-end text-end" data-bs-dismiss="modal"><a id="modalCloseButton" class="w-100 btn btn-danger btn-block btn-lg">'+i18n.get('Label-Genel-201')+'</a></div>')
				: ('<div class="col-6 float-end text-end"><a class="btn btn-danger btn-block btn-lg fs-14-mbl" href="'+ params.link + '">' + i18n.get('Label-Genel-202') +'</a></div>');

			var iconPartial = hasIcon ? '<div class="elem-icon big-icon p-15"><i class="fa fa-info-circle ' + iconClass + ' fa-3x float-start"></i></div>' : '';
			var contentPartial = hasIcon
				? '<div class="icon-text-partial">' + iconPartial +
				'<div class="elem-text" role="alert" aria-live="assertive">' +
				'<h4>' + i18n.get(title) + '</h4>' +
				messages +
				'</div></div>'
				: '<div role="alert" aria-live="assertive">' +
				'<h4>' + i18n.get(title) + '</h4>' +
				messages +
				'</div>';

			$('#' + wrapperId).html('');
			var insideHtml = '<div class="modal-dialog">'+
				'<div class="modal-content">'+
				'<div class="modal-body panel-body">'+
				'<div class="row grid-top">'+
				'<div class="col-12">'+
				contentPartial +
				'</div>'+
				'</div>'+
				'<div class="row grid justify-content-end">'+
				modalButton +
				'</div>'+
				'</div>'+
				'</div>'+
				'</div>';
			$('#' + wrapperId).html(insideHtml);

			var html = '<div class="modal" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" id="' + wrapperId + '">'+
				insideHtml +
				'</div>';



			if(!$('#modalContainer').length) {
				$('body').append('<div id="modalContainer"></div>');
			}

			var modalContainer = $('#modalContainer');
			modalContainer.html(html);
			$('#' + wrapperId).modal('show');

			$('#modalCloseButton').on({
				click: function() {
					if(params.reloadPage) {
						window.location.reload();
					} else if(params.callback) {
						params.callback();
					}else {
						modalContainer.remove();
						$('.modal-backdrop.show').remove();
					}
				}
			});
			$('#modalCloseButton').length && $._data($('#modalCloseButton')[0], 'events');
		}

		function convertToPassengerStatus(str) {
			var strArray = str.replace('{','').replace('}','').split(/, |=/)
			var result = {}
			var i ;
			for ( i=0 ; i < strArray.length; i +=2){
				var key = strArray[i];
				var val = strArray[i+1];
				result[key]= val
			}
			return result;
		}

		var createCovidModal = function(params) {
			var errorList = {};
			var errorText = 'Error-BOS-38010';
			try {
				errorText = params.error.messages[0].code;
				errorList = convertToPassengerStatus(params.error.messages[0].extraParameters[0]);
			} catch (e) {

			}

			var errorLabel = 'hesForm.form.result.';
			var text  = '';
			underscore.each(errorList, function(error, index) {
				var profile = window.postData.passengerProfiles[parseInt(index) - 1];
				if(profile) {
					text += profile.name + ' ' + profile.surname + ' : ' + i18n.get(errorLabel + error);
					text += '<br />';
				}
			});
			var messages = '<p>' + i18n.get(errorText) + '</p><p class="word-wrap">' + text + '</p>';

			var hasIcon = true;
			var iconClass = 'fa-exclamation-triangle red';
			var wrapperId = 'errorModal';
			var title = 'profile.hesWarning.title';

			var modalButton = '<div class="col-6 float-end" data-bs-dismiss="modal"><a id="modalCloseButton" class="w-100 btn btn-danger btn-block btn-lg">'+i18n.get('Label-Genel-201')+'</a></div>';

			var iconPartial = hasIcon ? '<div class="elem-icon big-icon pt-15"><i class="fa fa-info-circle ' + iconClass + ' fa-3x float-start"></i></div>' : '';
			var contentPartial = hasIcon ? '<div class="icon-text-partial">' + iconPartial + '<div class="elem-text"><h4>' + i18n.get(title) + '</h4>' + messages + '</div></div>'
				: '<h4>' + i18n.get(title) + '</h4>' + messages;

			var html = '<div class="modal" tabindex="-1" role="dialog" data-bs-backdrop="static" id="' + wrapperId + '">'+
				'<div class="modal-dialog">'+
				'<div class="modal-content">'+
				'<div class="modal-body panel-body">'+
				'<div class="row grid-top">'+
				'<div class="col-12">'+
				contentPartial +
				'</div>'+
				'</div>'+
				'<div class="row grid justify-content-end">'+
				modalButton +
				'</div>'+
				'</div>'+
				'</div>'+
			'</div>'+
		'</div>';
		
		if(!$('#modalContainer').length) {
			$('body').append('<div id="modalContainer"></div>');
		}
		
		var modalContainer = $('#modalContainer');
		modalContainer.html(html);
		$('#' + wrapperId).modal('show');
		
		$('#modalCloseButton').on({
			click: function() {
				if(params.reloadPage) {
					 window.location.reload();
				} else if(params.callback) {
					params.callback();
				}
			}
		});
		$('#modalCloseButton').length && $._data($('#modalCloseButton')[0], 'events');
	}

	var showErrorModal = function(msgCodes, returnHomepageLinkOnError) {
		var params = {
			msgs: msgCodes,
			type: 'error',
			link: returnHomepageLinkOnError
		}
		createValidationModal(params);
	}
	
	var showWarningModal = function(msgCodes) {
		var params = {
			msgs: msgCodes,
			type: 'warning'
		};
		createValidationModal(params);
	}

	var showInfoModal = function(headerText, msgCodes, reloadPage, callback) {
		var params = {
			title: headerText,
			msgs: msgCodes,
			type: 'info',
			reloadPage: reloadPage,
			callback: callback
		};
		createValidationModal(params);
	}
	
	var showSuccessInfoModal = function (msgCodes, reloadPage, callback) {
		var params = {
			msgs: msgCodes,
			type: 'info',
			reloadPage: reloadPage,
			callback: callback,
			hasIcon: false
		};
		createValidationModal(params);
	}
	
	var getServiceURL = function(app,service) {
		return serviceRegistry[app]+service;
	};
	
	var getAppURL = function(app) {
		return serviceRegistry[app];
	};
	
	var requestId = function() {
		var d = new Date().getTime()+Math.random()*Math.random();
		var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (d + Math.random()*16)%16 | 0;
			d = Math.floor(d/16);
			return (c==='x' ? r : (r&0x3|0x8)).toString(16);
		});
		return uuid;
	};
	
	var pageRequestId = function() {
		var prIdElement = $( "meta[name='PageRequestID']" );
		 
		var prId=null;
		 
		if(prIdElement) {
			prId = prIdElement.attr('content');
		}

		return prId;
	};

	var clientIdValue;
	var clientId = function() {
		if (localStorage.getItem('clientId') !== null) {
			clientIdValue = localStorage.getItem('clientId').replaceAll('"', '');
			return clientIdValue;
		} else {
			function getClientId() {
				return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
					return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
				});
			}
			clientIdValue = getClientId();
			localStorage.setItem('clientId', clientIdValue);
			return clientIdValue;
		}
	};
	
	function checkConnection() {
		var online = window.navigator.onLine, checkConnectionInterval;
		var connectionErrorText = i18n.get('ERR-GENEL-12');
		if(online) {
			clearInterval(checkConnectionInterval);
			$('#network-error-bar').remove();
		} else {
			checkConnectionInterval = setInterval(function() {
				online = window.navigator.onLine;
				if(online) {
					clearInterval(checkConnectionInterval);
					$('#network-error-bar').remove();
				} else if(!$('#network-error-bar').length) {
					var html = '<div id="network-error-bar"><div>' + connectionErrorText + '</div></div>'
					$('body').prepend(html);
				}
			}, 2000);
		}
	}
	
	var getConversationId = function() {
		if(window.cId==null) {
			window.cId = urlParser.getUrlVar("cId");
		}
		return window.cId;
	};

	var setTokenLocally = function(token) {
		token && storageHelper.setItem({
			key: "X-Token",
			value: JSON.stringify(token),
			webStorageType: storageHelper.Stores.LOCAL_STORAGE
		});
	}

	var post = function(settings) {
		
		var service = settings.service;
		var app = settings.app;
		var data = settings.data;
		if(data && settings.captchaCheck) {
			try {
				if(window.grecaptcha) {
					data.recaptchaInfo = { 'response': window.grecaptcha.getResponse(recaptchaRefId) };
				} else {
					if(!$('#captchaApi').length)
						recaptchaConstants.addRecaptchaV2ForEtrAjax();
				}
			} catch(err) {
				if(!$('#captchaApi').length)
					recaptchaConstants.addRecaptchaV2ForEtrAjax();
			}
		}
		var callback = settings.callback;
		var preSuccess = settings.preSuccess;
		var preError = settings.preError;
		var preErrorProperties = settings.preErrorProperties;
		var uiMap = settings.uiMap;
		var url = settings.url;
		var contentType = settings.contentType || "application/json; charset=utf-8";
		window.postData = data;
		if(contentType.indexOf("json")>=0)
			data = JSON.stringify(data);

		var async = settings.async != undefined ? settings.async : true;
		var timeout = 2000;
		
		if(!url) {
			url = getServiceURL(app,service);
			timeout = 90000;
		}
		var disableLoader = settings.disableLoader || false;
		var disableErrorHandling = settings.disableErrorHandling || false;
		var disableMSInactiveErrorHandling = settings.disableMSInactiveErrorHandling || false;
		var disableLoaderTimeout = settings.disableLoaderTimeout || false;
		var largeLoader = settings.largeLoader || false;
		var loaderName = settings.loaderName;
		var afterComplete = settings.complete;
		var reloadPageCSRF = settings.reloadPageCSRF;
		var returnHomepageLinkOnError = settings.returnHomepageLinkOnError;
		var returnHomepageErrorCodeList = settings.returnHomepageErrorCodeList;
		var darkPageActive = settings.darkPageActive || false;
		var forceExecuteDarkPageService = settings.forceExecuteDarkPageService || false;
		var darkPageAlternativeService = settings.darkPageAlternativeService;
		var executeCallbackOnError = settings.executeCallbackOnError || false;
		var isGlobal = settings.global != undefined ? settings.global : true;
		var returnToHomepageOnExceptionError = settings.returnToHomepageOnExceptionError || null;
		var returnToMyTripsOnExceptionError = settings.returnToMyTripsOnExceptionError || null;
		var setTokenX = settings.setTokenX || false;

		if(disableLoaderTimeout) {
			window.clearTimeout(loaderTimeout);
		}
		
		var sessionId = i18n.getMetaDataAttribute("jsessionid");
		
		if(sessionId) {
			url+=sessionId;
		}
		
		if(darkPageActive&&!forceExecuteDarkPageService) {
			
			if(darkPageAlternativeService) {
				darkPageAlternativeService();
			}
			return;
		}
		
		if(window.cId==null) {
				window.cId = urlParser.getUrlVar("cId");
			}
		if(window.cId!=null) {
			var redirectPage;

			var milesLogouted=	$.jStorage.get("app.miles/miles/logouted");
			if(milesLogouted) {
				var terminatedConversationIds=	$.jStorage.get("app.miles/miles/terminatedConversationIds");
				if( terminatedConversationIds.indexOf(window.cId) > -1) {
					redirectPage = findStartPageForRedirect(sessionStorage);
					window.location.href = redirectPage;
				}
			}
			var terminatedByCountLimitConversationIds=	$.jStorage.get("app/terminatedByCountLimitConversationIds");
			if(terminatedByCountLimitConversationIds) {
				if( terminatedByCountLimitConversationIds.indexOf(window.cId) > -1) {
					redirectPage = findStartPageForRedirect(sessionStorage);
					console.log(i18n.get('ERR-GENEL-04'));
					window.location.href = redirectPage;
				}
			}

		}
		!disableLoader && startLoading(loaderName,largeLoader,disableLoaderTimeout);
		$.ajax({
			url : url,
			type : "POST",
			contentType : contentType,
			async : async,
			timeout:timeout,
			data: data,
			cache : false,
			global : isGlobal,
			beforeSend : function(xhr) {
				xhr.setRequestHeader("Accept-Language", i18n.getUserLocale());
				xhr.setRequestHeader("country", i18n.getUserCountry());
				if(window.cId)
				{
					xhr.setRequestHeader('cId', window.cId);
				}
				xhr.setRequestHeader('page', window.location.href);
				xhr.setRequestHeader('requestId', requestId());
				xhr.setRequestHeader('pageRequestId', pageRequestId());
				xhr.setRequestHeader('clientId', clientId());

				if(localStorage.getItem('bfp') != null && localStorage.getItem('bfp').length){
					xhr.setRequestHeader('bfp', localStorage.getItem('bfp').replaceAll('"', ''));
				}
			},
			complete: function() {
				if(afterComplete) {
					afterComplete();
				}
				checkConnection();
				try {
					if(settings.captchaCheck && window.grecaptcha)
						window.grecaptcha.reset(recaptchaRefId);
				} catch(err) {
					if(!$('#captchaApi').length)
						recaptchaConstants.addRecaptchaV2ForEtrAjax();
				}
			},
			error: function() {
				if (preError) {
					preError();
				}
				callPreErrorFunction(preErrorProperties);
				stopLoading(largeLoader);
			},
			statusCode: {
				403: function() {
					showErrorModal(["Error-Genel-403"]);
				}
			},
			success : function(response, _status, xhr) {
				processCIDResponse(xhr);

				setTokenX && setTokenLocally(xhr.getResponseHeader("X-Token"));

                processBasketIdResponse(xhr);

				if(response.triggeredConversationEnd) {
					console.log(i18n.get('ERR-GENEL-04'));

					var terminatedByCountLimitConversationIds=	$.jStorage.get("app/terminatedByCountLimitConversationIds");
					if(!terminatedByCountLimitConversationIds) {
						terminatedByCountLimitConversationIds="";
					}

					terminatedByCountLimitConversationIds=terminatedByCountLimitConversationIds+","+response.triggeredConversationEnd;

					$.jStorage.set('app/terminatedByCountLimitConversationIds' , terminatedByCountLimitConversationIds);
				}

				if(response.redirect && !response.preventRedirect) {

					if (preSuccess) {
						preSuccess(response);
					}
					var ref = parseRedirectUrl(response.redirect);

					if(response.newWindow) {
						window.open(ref, '_blank','noopener');
						stopLoading(largeLoader);
					} else {

						document.location.href = ref;
					}

					return;
				} else {
					if (preSuccess) {
						preSuccess();
					}

					disableErrorHandling = checkDisableErrorHandling(response, disableErrorHandling, disableMSInactiveErrorHandling);

					if(!disableErrorHandling) {
						if(!handleAjaxError(response,preErrorProperties, reloadPageCSRF,returnHomepageLinkOnError,returnHomepageErrorCodeList, returnToHomepageOnExceptionError, returnToMyTripsOnExceptionError)) {
							var modalParams = {
								msgs: (response.infoMessages && response.infoMessages.length) || (response.error && response.error.validationMessages[0]),
								reloadPage: reloadPageCSRF,
								link: returnHomepageLinkOnError,
								type: 'error'
							};
							if(!handleValidationError(response, uiMap,preErrorProperties, modalParams)) {
								callCallbackSafely(callback, response);
							}
						} else if(executeCallbackOnError) {
							callCallbackSafely(callback, response);
						}
					} else {
						callCallbackSafely(callback, response);
					}

					if(largeLoader) {
						stopLoading(largeLoader);
					}
				}
			}
		});
	};

	var isErrorExists = function(response, errorCodes) {
		return response && response.type == "ERROR"
			&& response.error && response.error.messages && response.error.messages.length
			&& underscore.some(response.error.messages, function(message) {return errorCodes.includes(message.code)});
	}

	var checkDisableErrorHandling = function (response, disableErrorHandling, disableMSInactiveErrorHandling) {
		var msInactiveErrorExists = isErrorExists(response, ["ERR-MS-INACTIVE"]);
		if(msInactiveErrorExists) {
			return disableMSInactiveErrorHandling;
		}
		return disableErrorHandling;
	}

	var downloadFile = function(settings) {
		
		(function(settings) {
			
			var service = settings.service;
			var app = settings.app;
			var data = settings.data; 
			var id = settings.id;
			var url = getServiceURL(app,service);

			if(window.cId==null) {
					window.cId = urlParser.getUrlVar("cId");
			}
			
			var form;
			if(id) {
				form = $('<form id="form3457383' + id + '" method="POST" action="' + url + '" >');
			} else {
				form = $('<form method="POST" action="' + url + '" >');
			}
			
			
			var input = $('<input type="hidden" name="filedata" value="">');
			form.append(input);
			input.val(data.data);
			
			input = $('<input type="hidden" name="filename" value="">');
			form.append(input);
			input.val(data.filename);
			
			input = $('<input type="hidden" name="appcode" value="">');
			form.append(input);
			input.val(data.appcode);
			
			input = $('<input type="hidden" name="contenttype" value="">');
			form.append(input);
			input.val(data.contenttype);
			
			input = $('<input type="hidden" name="acceptlanguage" value="">');
			form.append(input);
			input.val(data.lang);
			
			if(data.newWindow) {				
				form.attr('target', '_blank').appendTo('body').submit();
			} else {
				form.appendTo('body').submit();
			}
			
			
			
		})(settings);
		
	};
		
	var remove = function(settings) {
		
		var service = settings.service;
		var app = settings.app;
		var data = settings.data;
		var callback = settings.callback;
		var uiMap = settings.uiMap;
		var reloadPageCSRF = settings.reloadPageCSRF;
		var returnHomepageLinkOnError = settings.returnHomepageLinkOnError;
		var preErrorProperties = settings.preErrorProperties;
		var async = settings.async !== undefined ? settings.async : true;
		var disableLoader = settings.disableLoader || false;
		var largeLoader = settings.largeLoader || false;
		var loaderName = settings.loaderName;
		var afterComplete = settings.complete;
		
		var url = getServiceURL(app,service);
		
		!disableLoader && startLoading(loaderName,largeLoader);
		$.ajax({
			url : url,
			type : "DELETE",
			contentType : "application/json; charset=utf-8",
			async : async,
				data: JSON.stringify(data), 
			cache : false,
			beforeSend : function() {
			},
			complete: function() {
				if(afterComplete) {
					afterComplete();
				}
				checkConnection();
			},
			error: function() {
			},
			success : function(response) {
				if(!handleAjaxError(response)) {
					var modalParams = {
						msgs: (response.infoMessages && response.infoMessages.length) || (response.error && response.error.validationMessages[0]),
						reloadPage: reloadPageCSRF,
						link: returnHomepageLinkOnError,
						type: 'error'
					};
					if(!handleValidationError(response, uiMap,preErrorProperties, modalParams)) {
						callCallbackSafely(callback, response);
					}
				}
			} 
		});
	};
	
	var put = function(settings) {
		
		var service = settings.service;
		var app = settings.app;
		var data = settings.data;
		var callback = settings.callback;
		var uiMap = settings.uiMap;
		var reloadPageCSRF = settings.reloadPageCSRF;
		var returnHomepageLinkOnError = settings.returnHomepageLinkOnError;
		var preErrorProperties = settings.preErrorProperties;
		var url = getServiceURL(app,service);
		var async = settings.async != undefined ? settings.async : true;
		var disableLoader = settings.disableLoader || false;
		var largeLoader = settings.largeLoader || false;
		var loaderName = settings.loaderName;
		var afterComplete = settings.complete;
		
		!disableLoader && startLoading(loaderName,largeLoader);
		$.ajax({
			url : url,
			type : "PUT",
			contentType : "application/json; charset=utf-8",
			async : async,
			data: JSON.stringify(data),
			cache : false,
			beforeSend : function() {
			},
			complete: function() {
				if(afterComplete) {
					afterComplete();
				}
				checkConnection();
			},
			error: function() {
			},
			statusCode: {
				403: function() {
					showErrorModal(["Error-Genel-403"]);
				}
			},
			success : function(response) {
				if(!handleAjaxError(response)) {
					var modalParams = {
						msgs: (response.infoMessages && response.infoMessages.length) || (response.error && response.error.validationMessages[0]),
						reloadPage: reloadPageCSRF,
						link: returnHomepageLinkOnError,
						type: 'error'
					};
					if(!handleValidationError(response, uiMap,preErrorProperties, modalParams)) {
						callCallbackSafely(callback, response);
					}
				}
			} 
		});
	};
	
	var processCIDResponse = function(xhr) {
		var cId = xhr.getResponseHeader('cId');
		if(cId != null) {
			window.cId = cId;	
			try {
				storageHelper.setItem({
					key: "cId",
					value: cId,
					webStorageType: storageHelper.Stores.SESSION_STORAGE
				});
				storageHelper.setItem({
					key: "X-conversationId",
					value: cId,
					webStorageType: storageHelper.Stores.SESSION_STORAGE
				});
			} catch (e) {
				console.dir(e)
			}
		}
	}

	var processBasketIdResponse = function(xhr) {
		var basketId = xhr.getResponseHeader("X-Basketid");
		if(basketId) {
			storageHelper.setItem({
				key: "X-Basketid",
				value: basketId,
				webStorageType: storageHelper.Stores.SESSION_STORAGE
			});
		}
	}

	var toCDNPATH = function(url) {
		if(window.cdnDomain) {
			url = window.cdnDomain+ url;
		}
		return url;
	};
	
	var convertToCdn = function(url) {
		var cdnUrl = url;
		if(url.indexOf("http://") != 0 && url.indexOf("https://") != 0) {
			cdnUrl = toCDNPATH(url);
		} 
		return cdnUrl;
	} 
	
	var get = function(setting) {
		var s = jqueryAjaxGetSettings(setting);
		runAjax(s);
	};
	
	var runAjax = function(settings) {
		if(!settings.disableLoader) {
			var promise = startLoading(settings.loaderName,settings.largeLoader, settings.disableLoaderTimeout);
			promise.then(function() {$.ajax(settings)}, function() {$.ajax(settings)});
		} else {
			$.ajax(settings);
		}
	};
	
	var jqueryAjaxGetSettings = function(settings) {
		var service = settings.service;
		var app = settings.app;
		var data = settings.data;
		if(data && settings.captchaCheck) {
			try {
				if(window.grecaptcha) {
					data.recaptchaResponse = window.grecaptcha.getResponse(recaptchaRefId);
				} else {
					if(!$('#captchaApi').length)
						recaptchaConstants.addRecaptchaV2ForEtrAjax();
				}
			} catch(err) {
				if(!$('#captchaApi').length)
					recaptchaConstants.addRecaptchaV2ForEtrAjax();
			}
		}
		var callback = settings.callback;
		var uiMap = settings.uiMap;
		var url = settings.url;
		var timeout = settings.timeout || 2000;
		var retryCount = settings.retryCount || 1;

		var async = underscore.isBoolean(settings.async) ? settings.async : true;
		var cache = underscore.isBoolean(settings.cache) ? settings.cache : false;
		var cdn = underscore.isBoolean(settings.cdn) ? settings.cdn : false;
		var addSessionId = underscore.isBoolean(settings.addSessionId) ? settings.addSessionId : false;

		var isGlobal = settings.global != undefined ? settings.global : true;
		
		if(!url) {
			url = getServiceURL(app,service);
			timeout = settings.timeout || 180000;
		}
		
		var preSuccess = settings.preSuccess;
		var preError = settings.preError;
		var preErrorProperties = settings.preErrorProperties;
		var reloadPageCSRF = settings.reloadPageCSRF;
		var returnHomepageLinkOnError = settings.returnHomepageLinkOnError;
		var returnHomepageErrorCodeList = settings.returnHomepageErrorCodeList;
		var disableLoader = settings.disableLoader || false;
		var disableErrorHandling = settings.disableErrorHandling || false;
		var disableMSInactiveErrorHandling = settings.disableMSInactiveErrorHandling || false;
		var disableLoaderTimeout = settings.disableLoaderTimeout || false;
		var executeCallbackOnError = settings.executeCallbackOnError || false;
		var requestHeaderParameters = settings.requestHeaderParameters;

		var largeLoader = settings.largeLoader || false;
		var loaderName = settings.loaderName;
		var afterComplete = settings.complete;
		var returnToHomepageOnExceptionError = settings.returnToHomepageOnExceptionError || null;
		var returnToMyTripsOnExceptionError = settings.returnToMyTripsOnExceptionError || null;

		if(window.cId==null) {
			window.cId = urlParser.getUrlVar("cId");
		}
		
		if(cdn) {
			url = convertToCdn(url);
		}
		
		var sessionId = i18n.getMetaDataAttribute("jsessionid");
		
		if(addSessionId && sessionId) {
			url+=sessionId;
		}
		
		return {
			url : url,
			type : "GET",
			contentType : "application/json; charset=utf-8",
			async : async,
			data: data, 
			cache : cache,
			disableLoader:disableLoader,
			disableLoaderTimeout:disableLoaderTimeout,
			loaderName:loaderName,
			largeLoader:largeLoader,
			global : isGlobal,
			timeout:timeout,
			retryCount: retryCount,
			error : function(_xhr, textStatus, _errorThrown ) {
				if (preError) {
					preError();
				}
				callPreErrorFunction(preErrorProperties);

				stopLoading(largeLoader);

				console.error("ajax error " + textStatus);
				if (textStatus == 'timeout' && this.retryCount) {
					this.retryCount--;
					if(this.retryCount > 0) {
						runAjax(this);
					}
					return;
				}
			},
			statusCode: {
				403: function() {
					showErrorModal(["Error-Genel-403"]);
				}
			},
			beforeSend : function(xhr) {
				if (cdn) {
					return;
				}
				xhr.setRequestHeader("Accept-Language", i18n.getUserLocale());
				xhr.setRequestHeader("country", i18n.getUserCountry());
				xhr.setRequestHeader('cId', window.cId);
				xhr.setRequestHeader('page', window.location.href);
				xhr.setRequestHeader('requestId', requestId());
				xhr.setRequestHeader('pageRequestId', pageRequestId());
				xhr.setRequestHeader('clientId', clientId());
				
				if(localStorage.getItem('bfp') != null && localStorage.getItem('bfp').length){
					xhr.setRequestHeader('bfp', localStorage.getItem('bfp').replaceAll('"', ''));
				}

				if(requestHeaderParameters) {
					$.each(requestHeaderParameters, function(key, value) {
						xhr.setRequestHeader(key, value);
					})
				}
			},
			complete: function() {
				if(afterComplete) {
					afterComplete();
				}
				checkConnection();					
				try {
					if(settings.captchaCheck && window.grecaptcha)
						window.grecaptcha.reset(recaptchaRefId);
				} catch(err) {
					if(!$('#captchaApi').length)
						recaptchaConstants.addRecaptchaV2ForEtrAjax();
				}
			},
			success : function(response, _status, xhr) {
				
				processCIDResponse(xhr);
				
				if(response.redirect) {
					var ref = parseRedirectUrl(response.redirect);
					if(response.newWindow) {
						window.open(ref, '_blank', 'noopener');
						stopLoading(largeLoader);
					} else {

						document.location.href = ref;
					}
				} else {
					if (preSuccess) {
						preSuccess();
					}
					
					disableErrorHandling = checkDisableErrorHandling(response, disableErrorHandling, disableMSInactiveErrorHandling);

					if(!disableErrorHandling) {
						if(!handleAjaxError(response,preErrorProperties, reloadPageCSRF, returnHomepageLinkOnError,returnHomepageErrorCodeList, returnToHomepageOnExceptionError, returnToMyTripsOnExceptionError)) {
							var modalParams = {
								msgs: (response.infoMessages && response.infoMessages.length) || (response.error && response.error.validationMessages[0]),
								reloadPage: reloadPageCSRF,
								link: returnHomepageLinkOnError,
								type: 'error'
							};
							if(!handleValidationError(response, uiMap,preErrorProperties, modalParams)) {
								callCallbackSafely(callback, response);
							}
						} else if(executeCallbackOnError) {
							callCallbackSafely(callback, response);
						}
					} else {
						callCallbackSafely(callback, response);
					}
				}
			}
			
		};
	};
	
	var redirectPage = function(redirectURL) {
		document.location.href = parseRedirectUrl(redirectURL); 
	};
	
	var multiGet = function(settings) {
		var arr = [];
		
		for (var i = 0; i < settings.length; i++) {
			var s = jqueryAjaxGetSettings(settings[i]);
			arr.push(s);
		}
		$.when(
			$.each(arr, function(i) {
				$.ajax(arr[i]);
			})
		).then(
			function() { },
			function() { console.error("ERRROR"); }
		);
	};
	
	$( document ).ajaxStart(function() {
		ajaxCallCount++;
	});
	
	$( document ).ajaxStop(function() {		
		setTimeout(function() {
			ajaxCallCount--;
			if(ajaxCallCount <= 0) {
				ajaxCallCount = 0;
				stopLoading('all');
			}
		}, ajaxLoaderClearTimeout)
	});

	return {
		post : post,
		downloadFile: downloadFile,
		get : get,
		remove:remove,
		put:put,
		multiGet:multiGet,
		getServiceURL:getServiceURL,
		getAppURL:getAppURL,
		handleAjaxError : handleAjaxError,
		startLoading : startLoading,
		stopLoading:stopLoading,
		getConversationId:getConversationId,
		redirectPage :redirectPage,
		showErrorModal :showErrorModal,
		showWarningModal:showWarningModal,
		showInfoModal : showInfoModal,
		showSuccessInfoModal : showSuccessInfoModal,
		pageRequestId:pageRequestId,
		requestId:requestId,
		clientId: clientId,
		parseRedirectUrl: parseRedirectUrl,
		ajaxLoaderClearTimeout : ajaxLoaderClearTimeout,
		setLoaderTemplate: setLoaderTemplate
	};

});
